/**
 * Wishlist Documentation:
 * https://developers.swym.it/docs/list-api
 */

let print = (text,data = "",color = "yellow",fontSize = 12) => {
  //console.log(`%c${text}`,`color:${color};font-size:${fontSize}px;font-weight:bold;`,data);
}
window.swatCustomEvents = {
  init : function(swat) {
    this.swat = swat;
    print("Function: swatCustomEvents.init",swat)
    document.addEventListener('variant:change', (event) => {
      this.handleVariantChange(swat,event,swat)
    });

    document.addEventListener('wishlist:add',(event) => {
      this.handleAddToWishlist(event.detail,swat);
      this.handleBackInStockAlert(event.detail,swat);
    });

    document.addEventListener("wishlist:remove",(event) => {
      this.removeItemFromWishlist(event.detail);
    });

    document.addEventListener("wishlist:removeProductsFromList",(event) => {
      this.removeProductsFromList(event.detail);
    });

    if (window.wishlistEnabled) {
      this.handleWishlistPage(swat);
      this.fatchWishlistProduct();
      this.handleWishlistRemove(swat);
      this.handleMoveToWishList(swat);
    }
    this.handleCartWishlistSection(swat);
    this.handleLogoutListener(swat);
  },

  removeSpecialCharsFromEmail(email) {
    const regex = /[^a-zA-Z0-9._-]/gi; // Regular expression for special characters
    return email.replace(regex, "");
  },

  async fetchProductList(){
    let listContent = [];
    for (let index = 1; index <= 10; index++) {
      print(`~~ ${index} fatching List..`,"","pink");
      
      const fetchPromise = new Promise((resolve, reject) => {
        swat.fetchLists({
          callbackFn: (lists) => resolve(lists),
          errorFn: (error) => reject(error),
        });
      });

      const fetchedLists = await fetchPromise;
      print(`~~ ${index} Fetched all Lists:`, fetchedLists,'green');
      if(fetchedLists.length > 0){
        listContent = fetchedLists;
        break;
      }
    }
    return listContent;
  },

  handleLogoutListener(swat){
    document.querySelectorAll('a[href="/account/logout"]').forEach(button => {
      button.addEventListener('click',(event) => {
        event.preventDefault();
        swat.disconnectShopperContext((param) => {
          window.location.href = button.href;
        }, (param) => {
        });
      });
    });
  },

  addProductToWishlist(lid,lname,data){
    let _this = this;
    var listUpdateConfig = {
      lid,
      lname,
      lprops:{
        email: data.email,
      }
    };
    
    swat.updateList(listUpdateConfig, function(updatedListObj) {
      print("Successfully updated the List", updatedListObj);

      let variantID = (data.variant) ? data.variant.id : data.wishlistButton.dataset.variantId;
      let product = {
        epi: variantID, // Unique variant ID of the product
        empi: data.product.id, // Master Product Id of the product
        du: `${window.location.origin}/products/${data.product.handle}`,
        cprops:{
          email: data.email,
          varaint: data.variant,
          product: data.product,
          notifyme_enabled: data.notifyme
        }
      };

      swat.addToList(lid, product, function(addedListItem) {
        data.wishlistButton.classList.remove('loading');
        if(data.wishlistButton.querySelector('.js-spinner')) data.wishlistButton.querySelector('.js-spinner').classList.add('hidden');
        if(data.wishlistButton.querySelector('span')) data.wishlistButton.querySelector('span').innerHTML = 'Item Added';
        
        _this.fatchWishlistProduct();
        setTimeout(() => {
          data.element.hide();
        }, 2000);
        if(data.reloadPage){
          window.location.reload();
        }
        if(data.callbackFn){
          data.callbackFn();
        }
      }, function(error) {
        //console.log("Error while adding the Product to the List", error);
      });

    }, function name(error) {
      //console.log("Error updating the List", error);
    });
  },

  handleAddToWishlist(data,swat){
    print("Function: handleAddToWishlist");
    let _this = this;

    // Define success callback
    let onSuccess = function(lists) {
      // Successfully fetched all lists 
      if(lists.length == 0){
        swat.createList({
            "lname": _this.removeSpecialCharsFromEmail(data.email)  // unique list name.
          }, function(newList){
            _this.addProductToWishlist(newList.lid,newList.lname,data);
          }, function(error) {
            console.log("Error while creating a List", error);
          });
      } else{
        let firstList = lists[0];
        _this.addProductToWishlist(firstList.lid,firstList.lname,data);
      }
    }

    // Define error callback
    let onError = function(error) {
      // Error is an xhrObject
      console.log("Error while fetching all Lists", error);
    }

    // Call `fetchLists` function
    swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });
  },

  handleBackInStockAlert(data,swat){
    print("Function: handleBackInStockAlert");

    // Define the email address you want to subscribe to
    let mediumValue = data.email;
    let medium = "email";
    let topic = "backinstock" // the topic of "backinstock" configured at our backend.

    let variantID = (data.variant) ? data.variant.id : data.wishlistButton.dataset.variantId;
    let variantPrice = (data.variant) ? data.variant.price : data.product.variants.filter(variant => variant.id == variantID)[0].price;

    // Product data of the product
    let product = {
      epi: variantID, // unique variant ID of the product.
      empi: data.product.id, // Product ID or master product ID
      du: `${window.location.origin}/products/${data.product.handle}`, // canonical product url.
      iu: data.product.featured_image, // image url for email
      pr: variantPrice, // price
      et: 8 // event type 8 stands for registering a "notify me" event.
    }
    
    // Sample call..
   
   if(data.notifyme){
    swat.sendWatchlist(mediumValue, medium, product, function(response){
    },function name(error) {
      console.log("There was an Error while subscribing the email for the alert.", error);
    }, 1);
   }
  },

  handleVariantChange(swat,event){
    print("Function: handleVariantChange");
    var variant_id = event.detail.variant.id;
    var wishlistButton =  event.detail.element.closest('modal-dialog').querySelector(".js-wishlist-submit-btn");
    swat.fetchLists({
      callbackFn: function(lists) {
        if(lists.length == 0){
          wishlistButton.classList.remove('disabled');
          wishlistButton.disabled = false;
          wishlistButton.querySelector('span').innerHTML = 'Submit';
        }else{
          let wishlistProducts = [];
          let wishlistData = lists.map(list => list.listcontents);
          wishlistProducts = wishlistProducts.concat(...wishlistData);
          let addedProduct = wishlistProducts.filter(wishlistProduct => (wishlistProduct.epi == variant_id))
          wishlistButton.disabled = !(addedProduct.length == 0);
          wishlistButton.classList.toggle('disabled',!addedProduct.length == 0);
          wishlistButton.querySelector('span').innerHTML = (addedProduct.length != 0) ? 'Item Added': 'Submit';
        }
      },
      errorFn: function(error){
        console.log("Error while fetching all Lists", error);
      }
    });
    if(wishlistButton){
      wishlistButton.setAttribute("data-variant-id", variant_id);
    }
  },
  
  async handleWishlistPage(swat){
    if (!document.body.classList.contains('template-name--account')) return;

   
    let lists = await this.fetchProductList();

    print("Function: handleWishlistPage",lists);

    let wishlistProducts = [];
    let wishlistData = lists.map(list => list.listcontents);
    wishlistProducts = wishlistProducts.concat(...wishlistData);

    document.querySelector('.js-wishlist-empity-msg').classList.toggle('hidden',!(wishlistProducts.length == 0));
    if(wishlistProducts.length == 0){
      document.querySelector('.js-wishlist-loading-wrapper').classList.add('hidden');
      return;
    }

    let wishlistVariantData = wishlistProducts.map(product => {
      let url = product.du;
      if(!url.includes('?variant=')) url = `${url}?variant=${product.epi}`;
      return {
        variantID: product.epi,
        url
      };
    });

    print("## Fetching Wishlist Products HTML....","","red",16);
    let variantHtml = [];
    for (let index = 0; index < wishlistVariantData.length; index++) {
      const variantData = wishlistVariantData[index];
      let fetchVariant = await fetch(`${variantData.url}&section_id=swym-wishlist-search`);
      let varaintResponce = await fetchVariant.text();
      let responceHtml = new DOMParser().parseFromString(varaintResponce,'text/html');
      let element = responceHtml.querySelector('.js-product');
      element.setAttribute('data-lid',wishlistProducts.find(product => (product.epi == variantData.variantID)).lid);
      variantHtml.push(element.outerHTML);
    }
    document.querySelector('.js-wishlist-loading-wrapper').classList.add('hidden');
    document.querySelector('.js-product-group--wrapper').innerHTML = variantHtml.join('');
    print("## Wishlist Products Loaded ....","","green",16);
    

   
  },

  handleWishlistRemove(swat){
    print("Function: handleWishlistRemove");
    let _this = this;
    customElements.define('wishlist-remove-button',class wishlistRemoveButton extends HTMLElement {
      connectedCallback(){
        this.querySelector('button').addEventListener('click',function() {
          this.disabled = true;
          this.classList.add('loading');
          this.querySelector('.js-spinner').classList.remove('hidden');
          let wrapper = this.closest('.js-product');

          document.dispatchEvent(new CustomEvent('wishlist:remove',{
            detail: {
              lid: wrapper.dataset.lid,
              variantId: wrapper.dataset.variantId,
              productId: wrapper.dataset.productId,
              productUrl: wrapper.dataset.url,
              button: this
            },
          }));
        });
      }
    });
  },

  async removeProductsFromList(detail){
    let element = detail.element;
    element.disabled = true;
    element.classList.add('disabled');
    let products = element.dataset.addedProducts.split(',').map(item => {
      let itemData = item.split('|');
      return {
        lid: itemData[0],
        empi: element.dataset.productId,
        epi: itemData[1],
        du: `${window.location.origin}/products/${element.dataset.productHandle}`
      }
    });
    
    for (let index = 0; index < products.length; index++) {
      const product = products[index];
      let productData = {
        epi: product.epi,
        empi: product.empi,
        du: product.du
      }
      const removePromise = new Promise((resolve, reject) => {
        this.swat.deleteFromList(
          product.lid,
          productData,
          (deletedProduct) => resolve(deletedProduct),
          (error) => reject(error)
        );
      });

      const removedProducts = await removePromise;
    }

    element.disabled = false;
    element.classList.remove('disabled','wishlist-added');

  },

  removeItemFromWishlist(detail){
    let product = {
      epi: detail.variantId,
      empi: detail.productId,
      du: detail.productUrl
    };

    this.swat.deleteFromList(detail.lid, product, function(deletedProduct) {
      let forWishlist = detail.button.closest('#for_wishlist');
      if(detail.button.closest('cart-your-wish-list')){
        detail.button.closest('cart-your-wish-list').init();
      }
      if(detail.removeElement){
        detail.removeElement.remove();
      }
      if(detail.button.closest('.js-product')) detail.button.closest('.js-product').remove();
      if(forWishlist){
        if(forWishlist.querySelectorAll('.js-product').length == 0){
          document.querySelector('.js-wishlist-product').classList.add('hidden');
          document.querySelector('.js-wishlist-empity-msg').classList.remove('hidden');
        }
      }
      if(detail.reloadPage == true){
        window.location.reload();
      }
    }, function(error) {
      console.log("Error while deleting the Product", error);
    });
  },

  async fatchWishlistProduct(){
    let lists = await this.fetchProductList();
    print("Function: fatchWishlistProduct",lists);
    let wishlistProducts = [];
    let wishlistData = lists.map(list => list.listcontents);
    let _wishlistData = wishlistProducts.concat(...wishlistData);
    wishlistProducts = _wishlistData.map(data => data.empi);
    let uniqueId =[...new Set(wishlistProducts)];    
    uniqueId.forEach(productId => {
      let addedVariants = _wishlistData.filter(product => product.empi == productId).map(product => {
        return `${product.lid}|${product.epi}`;
      });
      let element = document.querySelectorAll(`.js-wishlist-icon-btn[data-product-id="${productId}"]`);
      element.forEach(button => {
        button.classList.add('wishlist-added');
        button.setAttribute('data-added-products',addedVariants.join(','));
      });
    });
  },

  handleMoveToWishList(swat){
    customElements.define('move-to-wishlist-btn', class moveToWishlistBtn extends HTMLElement{
      connectedCallback(){
        this.CartItems = this.closest('cart-items');
        this.currentVariant = JSON.parse(this.querySelector('.variant-json').innerHTML);
        this.productdata = JSON.parse(this.querySelector('.product-json').innerHTML);
        this.wishlistButton = this.querySelector('.js-wishlist-button');
        this.wishlistButton.addEventListener('click',this.handleClickListener.bind(this));
        this.emailInput = this.querySelector('.js-email-input');
      }
      handleClickListener(event){
        let itemKey = this.dataset.key;
        let updates = {};
        updates[itemKey] = 0;
        if(this.CartItems){
          this.CartItems.enableLoading(this.dataset.line);
        }
        if(this.closest('modal-dialog')){
          this.wishlistButton.classList.add('loading');
          this.wishlistButton.querySelector('.js-spinner').classList.remove('hidden');
        }
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          return response.json();
        })
        .then(updateResponce => {
          document.dispatchEvent(new CustomEvent('wishlist:add',{
            detail: {
              element: this,
              wishlistButton: this.wishlistButton,
              variant: this.currentVariant,
              email: this.emailInput.value,
              notifyme: false,
              product: this.productdata,
              callbackFn: this.callbackFn.bind(this)
            },
          }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });        
      }
      callbackFn(){
        if(this.closest('modal-dialog')){
          this.wishlistButton.classList.remove('loading');
          this.wishlistButton.querySelector('.js-spinner').classList.add('hidden');
          this.closest('modal-dialog').hide();
        }
        window.location.reload();
      }
    });
  },

  handleCartWishlistSection(swat){
    print("Function: handleCartWishlistSection");
    customElements.define('cart-your-wish-list',class cartYourWishList extends HTMLElement{
      connectedCallback(){
        this.init();
      }
      init(){
        this.classList.add('hidden');
        if(this.slider){
          this.slider.destroy();
        }
        if(window.wishlistEnabled){
          swat.fetchLists({
            callbackFn: this.wishlistSuccess.bind(this),
            errorFn: function(error) {
            }
          });
        }else{
          if(this.hasAttribute('hide-recommandation')){
            this.classList.add('hidden');
          }else{
            this.classList.remove('hidden');
            this.initilizeSlider();
          }
        }
      }
      async wishlistSuccess(lists){
        let wishlistProducts = [];
        let wishlistData = lists.map(list => list.listcontents);
        wishlistProducts = wishlistProducts.concat(...wishlistData);

        let wishlistVariantData = wishlistProducts.filter(product => {
          let variant = product.cprops.variant;
          if(!variant){
            variant = product.cprops.product.variants.filter(_vari => (_vari.id == product.epi))[0];
            product.cprops.variant = variant;
          }
          return variant.available == true
        }).map(product => {
          let url = product.du;
          if(!url.includes('?variant=')) url = `${url}?variant=${product.epi}`;
          return {
            available: product.cprops.variant.available,
            variantID: product.epi,
            url
          };
        });

        if(wishlistVariantData.length == 0){
          if(this.hasAttribute('hide-recommandation')){
            this.classList.add('hidden');
          }else{
            this.fetchRecommandationProducts();
          }
          return;
        }
        
        this.querySelector('.js-slider-buttons').classList.toggle('hidden',wishlistVariantData.length <= 3);

        print("## Fetching Your Wishlist Products HTML....","","red",16);
        let variantHtml = [];
        let loopLength = (wishlistVariantData.length > 6) ? 6 : wishlistVariantData.length;
        for (let index = 0; index < loopLength; index++) {
          const variantData = wishlistVariantData[index];
          let fetchVariant = await fetch(`/variants/${variantData.variantID}?section_id=${this.dataset.sectionId}`);
          let varaintResponce = await fetchVariant.text();
          let responceHtml = new DOMParser().parseFromString(varaintResponce,'text/html');
          let element = responceHtml.querySelector('.js-ajax-variant-data');
          let wrapperelement = responceHtml.querySelector('.js-product');
          wrapperelement.setAttribute('data-lid',wishlistProducts.find(product => (product.epi == variantData.variantID)).lid);
          variantHtml.push(element.innerHTML);
        }
        this.querySelector('.js-section-title').innerHTML = this.dataset.wishlistTitle;
        this.querySelector('.js-wishlist-products--wrapper').innerHTML = variantHtml.join('');
        this.classList.remove('hidden');
        print("## Your Wishlist Products Loaded ....","","green",16);

        this.initilizeSlider();
      }
      fetchRecommandationProducts(){
        fetch(this.dataset.url)
        .then((response) => {
          if(response.status == 404) this.classList.add('hidden');
          return response.text();
        }).then(responceHtml => {
          const html = document.createElement('div');
          html.innerHTML = responceHtml;
          const cartYourWishListResponce = html.querySelector('cart-your-wish-list');
          this.innerHTML = cartYourWishListResponce.innerHTML;
          this.querySelector('.js-section-title').innerHTML = this.dataset.recommandationTitle;
          this.classList.remove('hidden');
          this.initilizeSlider();
        });
      }
      initilizeSlider(){
        let prevButton = this.querySelector('.button--previous');
        let nextButton = this.querySelector('.button--next');
        this.slider = new Flickity(this.querySelector('.js-wishlist-products--wrapper'), {
          cellAlign: 'left',
          contain: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons:true,
          on: {
            scroll: progress=>{
              let calc = Math.max(0, Math.min(1, progress));
              prevButton && (prevButton.disabled = calc == 0),
              nextButton && (nextButton.disabled = calc == 1)
            },
            ready: function (params) {
              prevButton.addEventListener('click', () => this.previous());
              nextButton.addEventListener('click', () => this.next());
              setTimeout(() => {
                window.setGridHeight('cart-your-wish-list .product-card-wrapper .card__heading');
                window.setGridHeight('cart-your-wish-list .product-card-wrapper .card__information');
                this.reloadCells();
              }, 1000);
            }
          }
        });
      }
    });
  }
}


function swymCallbackFn(swat){
  window.swat = swat;
  window.swatCustomEvents.init(swat);

 

}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);